// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"b22631e2","496":"8d8889c6","647":"76f264f6"}[chunkId] + ".chunk.js";
};